(function (appComponents) {

	appComponents.services.cartCheckout = function (Components) {

		var cartCheckout = {};
		var data= {};

		cartCheckout.name = "cartCheckout";


        Components.getComponentPrototype().extend(cartCheckout);
				
		cartCheckout.elements = {
			get orderCheckoutModal() {
				return $("[pc-container='order-checkout--modal']");
			},
			get quoteCheckoutModal() {
				return $("[pc-container='quote-checkout--modal']");
			}
		};

		cartCheckout.showForOrder = function () 
		{
			cartCheckout.elements.orderCheckoutModal.modal("show");
		};

		cartCheckout.hideForOrder = function () 
		{
			cartCheckout.elements.orderCheckoutModal.modal("hide");
		};

		cartCheckout.showForQuote = function () 
		{
			cartCheckout.elements.quoteCheckoutModal.modal("show");
		};

		cartCheckout.hideForQuote = function () 
		{
			cartCheckout.elements.quoteCheckoutModal.modal("hide");
		};

		cartCheckout.handlers = {
			doCheckout: function () {
				context = { mandatoryFlag : "true" };
			},
			proceedWithoutAdding: function () {
				context = { mandatoryFlag : "false" };
			},
			addMandatoryKits : function()
			{ 
				//
			}
			};
	
		cartCheckout.init = function()
		{
			//
		};

		return cartCheckout;
		};

        window.appComponents = appComponents;

    })(window.appComponents || {});